import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

const ACCEPT = ["image/jpeg", "image/png", "image/webp"];
const MAX_MB = 8;

/** Client-side pre-checks only; the server re-validates and re-encodes every image. */
export function validateImageFile(file) {
  if (!ACCEPT.includes(file.type)) return "Yalnızca JPEG, PNG veya WEBP yükleyebilirsiniz";
  if (file.size > MAX_MB * 1024 * 1024) return `Dosya ${MAX_MB} MB'tan büyük olamaz`;
  return null;
}

export default function PhotoUploader({ photos, onChange, max = 10 }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const onFiles = async (files) => {
    setBusy(true);
    const added = [];
    for (const file of Array.from(files).slice(0, max - photos.length)) {
      const bad = validateImageFile(file);
      if (bad) { toast.error(`${file.name}: ${bad}`); continue; }
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/uploads/image", fd);
        added.push(data);
      } catch (e) { toast.error(`${file.name}: ${errMsg(e)}`); }
    }
    onChange([...photos, ...added]);
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
        {photos.map((p, i) => (
          <div key={p.id} className="relative aspect-square overflow-hidden rounded border border-black/[0.08]" data-testid={`photo-thumb-${i}`}>
            <img src={fileUrl(p.url)} alt="Yüklenen fotoğraf" loading="lazy" decoding="async" className="h-full w-full object-cover" />
            <button type="button" data-testid={`photo-remove-${i}`} onClick={() => onChange(photos.filter((x) => x.id !== p.id))}
              className="absolute right-1 top-1 rounded bg-white/90 p-1"><X className="h-3 w-3" /></button>
            {i === 0 && <span className="absolute bottom-1 left-1 rounded bg-[#0071e3] px-1 text-[10px]">Kapak</span>}
          </div>
        ))}
        {photos.length < max && (
          <button type="button" data-testid="photo-add-button" onClick={() => ref.current?.click()} disabled={busy}
            className="flex aspect-square flex-col items-center justify-center gap-1 rounded border border-dashed border-black/[0.08] text-xs text-zinc-500 hover:border-[#0071e3]">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />} Fotoğraf ekle
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept={ACCEPT.join(",")} multiple hidden data-testid="photo-file-input" onChange={(e) => onFiles(e.target.files)} />
      <p className="mt-2 text-xs text-zinc-500">JPEG/PNG/WEBP, en fazla {MAX_MB} MB. Güvenlik için tüm görseller sunucuda doğrulanır, meta verileri temizlenerek yeniden işlenir.</p>
    </div>
  );
}
